<template>
    <div class="rp-helpdesk-conversation-message-journey" @click="$emit('click')">
        <div class="rp-helpdesk-conversation-message-journey-box">
            <p class="order-creadcrumb" v-html="journeyInnerHtml"></p>
    	</div>
    </div>
</template>

<script>

export default {
    name: 'MediaTypeJourney',
    props: {

        message: {
            type: Object,
            required: true
        }

    },
    computed: {
        journeyInnerHtml() {
            const value = JSON.parse(this.message.mediaFormValue[0].value)
            const length = value.length;
            let innerHtml = '';
            for (let i = 0; i < length; i++) {
                if(i === 0) {
                    innerHtml += `<span class="journey-step">${value[i]}</span>`
                } else {
                    innerHtml += `<i class="el-icon-arrow-right"></i><span class="journey-step">${value[i]}</span>`
                }
            }
            return innerHtml
        }
    }

}
</script>

<style lang="scss">
    .rp-helpdesk-conversation-message-journey-box {
        display: inline-block;
        padding: 1rem;
        border-radius: 7px;
        border: 1px solid #cccccc;
        max-width: 85%;
        font-weight: $fontWeight;
        line-height: 22px;
        font-size: 15px;
        @include for-size(desktop-up){
            font-size: 16px;
        }

        p.order-creadcrumb {
            margin: 0;
            text-align: left;
            

            .el-icon-arrow-right {
                margin: 0 8px;
                font-size: 12px;
                color: #666666;
                @include for-size(desktop-up){
                    font-size: 16px;
                }
            }
        }
    }

</style>
